const MDUMFeatureFlags = {
  application: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  mdum: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  viewCountriesAndPricingLink: {
    Production:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    PreProduction:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    UAT:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    SVT:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    QA:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    Mock:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    Development:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
    Local:
      'https://www.telstra.com.au/business-enterprise/products/mobility-solutions/plans-and-devices/international-roaming',
  },
  enableR15TEDT30347: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: true,
  },
  tedig2492RedirectMaximToTnow: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: true,
    Development: false,
    Local: true,
  },
}

export default MDUMFeatureFlags
